<template>
    <div id="tableSales">
      <Datatable
        entity="pos_payment"
        :parameters="datatableParameters"
        :onRowClick="onRowClick"
      />
    </div>
</template>

<script>
  import Datatable from "@/components/Datatable";

  export default {
    name: "TableSales",
    components: {Datatable},

    computed: {
      datatableParameters() {
        return {
          company: this.$route.query.company
        }
      }
    },

    methods: {
      onRowClick(row) {
        this.$router.push(this.$router.buildContext("/sale", {id: `pos${row.id}`}));
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>